<template>
  <div>
    <v-card class="my-4" flat>
      <v-card-text>
        <v-list-item>
          <v-list-item-avatar size="78">
            <img
              :alt="user.user_name"
              :src="user.avatar || 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              <a v-if="getName(user) !== ''" :title="getUserName(user)" class="sr-mention" v-html="getName(user)"></a>
              <a
                  v-if="getName(user) === '' && getUserName(user) !== ''"
                  class="sr-mention"
                  v-text="'@' + getUserName(user)"
              ></a>
              <a
                  v-if="getName(user) === '' && getUserName(user) === ''"
                  class="sr-mention"
                  v-text="'@' + getOrigin(user)"
              ></a>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span class="font-weight-medium"> {{ $t("dashboard.ranking.publications") }} : </span>
              {{ user.publication_counter }}
              <span class="ml-4 font-weight-medium"> {{ $t("dashboard.ranking.created") }} : </span>
              {{ user.created_at | moment("from") }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <hr />
    </v-card>
    <v-card
      v-for="publication in publications"
      :key="publication.id + publication.database"
      class="my-4"
      flat
      @click="openUrl(publication.url)"
    >
      <v-card-text>
        <v-row>
          <v-col class="tw-flex tw-items-center tw-justify-between">
            <span class="ml-2">
              <v-icon x-small>fa-globe</v-icon>
              {{ publication.host }}
            </span>
            <span class="ml-2">{{ formatPublicationDate(publication) }}</span>
            <span class="ml-2">
              <v-icon color="secondary" style="margin-bottom: 3px;" x-small>fa-star</v-icon>
              {{ publication.rating }}/5
            </span>
            <span v-if="publication.like && publication.like.counter > 0" class="ml-2" x-small>
              <v-icon class="pb-1" x-small>fa-thumbs-up</v-icon>
              {{ publication.like.counter }}
            </span>
          </v-col>
        </v-row>

        <v-row class="container">
          {{ publication.message }}
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Types as TypesLoading } from "@/store/modules/loading"

export default {
  name: "RankingListSelected",
  props: {
    user: { type: Object, required: true },
  },
  data: () => ({
    publications: [],
  }),
  watch: {
    user: function() {
      this.publications = []
      this.loadPublications()
    },
  },
  mounted() {
    this.publications = []
    this.loadPublications()
  },
  methods: {
    getUserName(user) {
      const semicolonPos = user.user_name.indexOf(":")
      if (semicolonPos > 0) {
        return ""
      } else {
        return `${user.user_name}`
      }
    },
    getName(user) {
      let name = ""
      if (user.first_name) name = name + " " + user.first_name
      if (user.last_name) name = name + " " + user.last_name
      return name.trim()
    },
    formatPublicationDate(publication) {
      let dt = new Date(publication.created_at)
      return dt.toLocaleDateString("fr-fr")
    },
    slicedUrl(url) {
      const limit = 100
      const sliced = url.slice(0, limit)
      return limit <= url.length ? sliced + "..." : url
    },
    loadPublications() {
      this.$store.commit(
        TypesLoading.mutations.LOADING_YES,
        this.$t("ranking.messages.loading") + "<b>@" + this.user.user_name + "</b>"
      )
      this.$axios
        .get(`office/me/users/ranking/${this.user.id}`)
        .then(response => (this.publications = response.data))
        .finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    openUrl(url) {
      window.open(url, "_blank")
    },
  },
}
</script>
